/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Auction } from '../models/auction';
import { AuctionWithRelations } from '../models/auction-with-relations';
import { inventoryCreateAuction } from '../fn/inventory-auctions-controller/inventory-create-auction';
import { InventoryCreateAuction$Params } from '../fn/inventory-auctions-controller/inventory-create-auction';
import { inventoryDeleteAuction } from '../fn/inventory-auctions-controller/inventory-delete-auction';
import { InventoryDeleteAuction$Params } from '../fn/inventory-auctions-controller/inventory-delete-auction';
import { inventoryGetAuction } from '../fn/inventory-auctions-controller/inventory-get-auction';
import { InventoryGetAuction$Params } from '../fn/inventory-auctions-controller/inventory-get-auction';
import { inventoryGetAuctions } from '../fn/inventory-auctions-controller/inventory-get-auctions';
import { InventoryGetAuctions$Params } from '../fn/inventory-auctions-controller/inventory-get-auctions';
import { inventoryUpdateAuction } from '../fn/inventory-auctions-controller/inventory-update-auction';
import { InventoryUpdateAuction$Params } from '../fn/inventory-auctions-controller/inventory-update-auction';
import { moveAuctionToGlobal } from '../fn/inventory-auctions-controller/move-auction-to-global';
import { MoveAuctionToGlobal$Params } from '../fn/inventory-auctions-controller/move-auction-to-global';

@Injectable({ providedIn: 'root' })
export class InventoryAuctionsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `auctionControllerMoveAuctionToGlobal()` */
  static readonly AuctionControllerMoveAuctionToGlobalPath = '/inventory/auctions/move-to-global';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `moveAuctionToGlobal()` instead.
   *
   * This method doesn't expect any request body.
   */
  moveAuctionToGlobal$Response(params: MoveAuctionToGlobal$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return moveAuctionToGlobal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `moveAuctionToGlobal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  moveAuctionToGlobal(params: MoveAuctionToGlobal$Params, context?: HttpContext): Observable<any> {
    return this.moveAuctionToGlobal$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `auctionControllerInventoryGetAuction()` */
  static readonly AuctionControllerInventoryGetAuctionPath = '/inventory/auctions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryGetAuction()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetAuction$Response(params: InventoryGetAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionWithRelations>> {
    return inventoryGetAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryGetAuction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetAuction(params: InventoryGetAuction$Params, context?: HttpContext): Observable<AuctionWithRelations> {
    return this.inventoryGetAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuctionWithRelations>): AuctionWithRelations => r.body)
    );
  }

  /** Path part for operation `auctionControllerInventoryUpdateAuction()` */
  static readonly AuctionControllerInventoryUpdateAuctionPath = '/inventory/auctions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryUpdateAuction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryUpdateAuction$Response(params: InventoryUpdateAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return inventoryUpdateAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryUpdateAuction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryUpdateAuction(params: InventoryUpdateAuction$Params, context?: HttpContext): Observable<any> {
    return this.inventoryUpdateAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `auctionControllerInventoryGetAuctions()` */
  static readonly AuctionControllerInventoryGetAuctionsPath = '/inventory/auctions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryGetAuctions()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetAuctions$Response(params: InventoryGetAuctions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuctionWithRelations>>> {
    return inventoryGetAuctions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryGetAuctions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetAuctions(params: InventoryGetAuctions$Params, context?: HttpContext): Observable<Array<AuctionWithRelations>> {
    return this.inventoryGetAuctions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AuctionWithRelations>>): Array<AuctionWithRelations> => r.body)
    );
  }

  /** Path part for operation `auctionControllerInventoryCreateAuction()` */
  static readonly AuctionControllerInventoryCreateAuctionPath = '/inventory/auctions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryCreateAuction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryCreateAuction$Response(params: InventoryCreateAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<Auction>> {
    return inventoryCreateAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryCreateAuction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryCreateAuction(params: InventoryCreateAuction$Params, context?: HttpContext): Observable<Auction> {
    return this.inventoryCreateAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<Auction>): Auction => r.body)
    );
  }

  /** Path part for operation `auctionControllerInventoryDeleteAuction()` */
  static readonly AuctionControllerInventoryDeleteAuctionPath = '/inventory/auctions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryDeleteAuction()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryDeleteAuction$Response(params: InventoryDeleteAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return inventoryDeleteAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryDeleteAuction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryDeleteAuction(params: InventoryDeleteAuction$Params, context?: HttpContext): Observable<any> {
    return this.inventoryDeleteAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
